import api from '../api'

const baseUrl = '/academy/api/AdminPackage'

const dadbanPackageProvider = {
  getAllPackages(params = {}) {
    return api.post(`${baseUrl}/Table`, {
      params,
    })
  },

  getPackage(id) {
    return api.get(`${baseUrl}/Get/${id}`)
  },

  getInputs() {
    return api.get(`${baseUrl}/Input`)
  },

  addPackage(params) {
    return api.post(`${baseUrl}/Add`, params)
  },

  updatePackage(params = {}) {
    return api.put(`${baseUrl}/Edit`, params)
  },

  deletePackage(params) {
    return api.delete(`${baseUrl}/Delete/${params}`)
  },
  deletePackageCourse(params = {}) {
    return api.delete(`${baseUrl}/DeleteCourse`, { data: params })
  },

  searchPackageCourse(params) {
    return api.post(`${baseUrl}/SearchCourse`, params)
  },
  addPackageCourse(params) {
    return api.post(`${baseUrl}/AddCourse`, params)
  },
  addPackagePrerequisite(params) {
    return api.post(`${baseUrl}/Prerequisite`, params)
  },

  searchPackagePrerequisite(params) {
    return api.post(`${baseUrl}/SearchPrerequisite`, params)
  },

  deletePackagePrerequisite(params = {}) {
    return api.delete(`${baseUrl}/Prerequisite`, { params })
  },
}

export default dadbanPackageProvider
